module.exports = __webpack_public_path__ + "static/img/user_story1.8836ec5d.png";